import React from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import useLeaderboard from 'hooks/useLeaderboard';
import { routes } from '../../routing/routes';

export default function Leaderboard() {
  const { type } = useParams();
  const { leaderboard, isLoading } = useLeaderboard(type);

  if (isLoading || !leaderboard) {
    return null;
  }

  const { title, subTitle, hideBreakerStatus, entries } = leaderboard;

  return (
    <main className="leaderboard">
      <Helmet>
        <title>{`${title} - DuskBreakers`}</title>
        <meta name="description" content={`${title} - DuskBreakers`} />
      </Helmet>
      <section>
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href={routes.leaderboards.base()}>Leaderboards</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {title}
                  </li>
                </ol>
              </nav>
              <h1 className="mb-3">
                <span>{title}</span>
              </h1>
              <p className="text-muted mb-5">{subTitle}</p>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-md-8">
              <table className="table leader-table">
                <thead>
                  <tr>
                    <th>Breaker Name</th>
                    {!hideBreakerStatus && <th>Active Breaker?</th>}
                    <th>Rank</th>
                    <th>High Score</th>
                  </tr>
                </thead>
                <tbody>
                  {entries.map(({ displayname, rank, score, isBreaker }) => {
                    return (
                      <tr key={displayname}>
                        <td className="name">{displayname}</td>
                        {!hideBreakerStatus && (
                          <td className="name">
                            {isBreaker ? <span className="text-green">Yes</span> : <span>No</span>}
                          </td>
                        )}
                        <td className="rank">{rank}</td>
                        <td className="score">{score}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
